import { render, staticRenderFns } from "./dataCount.vue?vue&type=template&id=74566124&scoped=true&"
import script from "./dataCount.vue?vue&type=script&lang=js&"
export * from "./dataCount.vue?vue&type=script&lang=js&"
import style0 from "./dataCount.vue?vue&type=style&index=0&id=74566124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74566124",
  null
  
)

component.options.__file = "dataCount.vue"
export default component.exports